<template>
  <div class="mt-5">
    <p class="foot text-muted">Follow Us On Social Media</p>
    <div>
      <b-button variant="outline-dark" class="btn-lg button" href="https://instagram.com/miamischools">
        <font-awesome-icon :icon="['fab', 'instagram']" />
        <span class="sr-only">Miami-Dade County Public Schools' Instagram Page</span>
      </b-button>
      <b-button variant="outline-dark" class="btn-lg button" href="https://twitter.com/MDCPS">
        <font-awesome-icon :icon="['fab', 'twitter']" />
        <span class="sr-only">Miami-Dade County Public Schools' Twitter Page</span>
      </b-button>
      <b-button variant="outline-dark" class="btn-lg button" href="https://www.facebook.com/miamischools">
        <font-awesome-icon :icon="['fab', 'facebook-f']" />
        <span class="sr-only">Miami-Dade County Public Schools' Facebook Page</span>
      </b-button>
      <b-button variant="outline-dark" class="btn-lg button" href="https://www3.dadeschools.net/home">
        <font-awesome-icon :icon="['fas', 'globe-americas']" />
        <span class="sr-only">Miami-Dade County Public Schools' Website</span>
      </b-button>
      <b-button variant="outline-dark" class="btn-lg button" href="https://www.youtube.com/user/miamischools">
        <font-awesome-icon :icon="['fab', 'youtube']" />
        <span class="sr-only">Miami-Dade County Public Schools' Youtube Channel</span>
      </b-button>
      <p class="text-muted">2021 © Miami-Dade County Public Schools.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterBar",
};
</script>

<style lang="scss" scoped>
.foot {
  font-size: 1vw;
}

.button {
  background: transparent;
  border: none !important;
}

@media screen and (max-width: 1200px) {
  .foot {
    font-size: 20px;
  }
}
</style>